import React from "react";

export default function LocationForm({ location, reason, onChangeLocation, onChangeReason }) {
  const set = (k, v) => onChangeLocation({ ...location, [k]: v });
  return (
    <div className="cn-card">
      <h3>Location</h3>
      <div className="row">
        <div>
          <label>Location</label>
          <input value={location.location} onChange={(e) => set("location", e.target.value)} />
        </div>
        <div>
          <label>Address</label>
          <input value={location.location2} onChange={(e) => set("location2", e.target.value)} />
        </div>
        <div>
          <label>Ph/Fax</label>
          <input value={location.location1} onChange={(e) => set("location1", e.target.value)} />
        </div>
      </div>
      <div style={{ marginTop: 8 }}>
        <label>Reason for Appointment</label>
        <textarea
          value={reason.reasonForAppointment}
          onChange={(e) => onChangeReason({ reasonForAppointment: e.target.value })}
          rows={2}
        />
      </div>
    </div>
  );
}
